module.exports = __webpack_public_path__ + "static/media/card2.a0b53a16.png";